<template>
  <figure class='video wrapper'>
      <svg v-if='!videoInitiated' width="147" height="274" viewBox="0 0 147 274">
        <path d="M143 137L7 59V215L143 137Z" />
      </svg>
      <img v-if='!videoInitiated' :src='getThumbnailUrl(props.url)' @click='clicked()'/>
      <LoadWhenVisible :throttle='800'>
        <YouTube :class='{active : videoInitiated}' class='youtube wrapper' width='100%' height='100%' :src='props.url' :vars='youtubeOptions' ref='youtubePlayer' />
      </LoadWhenVisible>
  </figure>
</template>

<script setup>
  import YouTube from 'vue3-youtube'

  const props = defineProps({
    mute: {
        default: 0,
        type: Number,
    },
    autoplay: {
        default: 0,
        type: Number,
    },
    loop: {
        default: 1,
        type: Number,
    },
    url: {
        type: String,
        required: true,
    }
  });
  const youtubeOptions = ref({
    autoplay: props.autoplay,
    playsinline: 1,
    mute: props.mute,
    loop: props.loop,
    controls: 0,
    showinfo: 0,
    wmode: 'transparent',
    rel: 0,
    iv_load_policy: 3
  });
  const videoInitiated = ref(false);
  const youtubePlayer = ref(null);
  const play = () => youtubePlayer.value.playVideo();
  const pause = () => youtubePlayer.value.pause();
  const clicked = () => {
    console.log(youtubePlayer.value);
    videoInitiated.value = true;
    youtubePlayer.value.playVideo(2);
  }
  const getThumbnailUrl = url => `https://img.youtube.com/vi/${url.split('v=')[1]}/0.jpg`;
  defineExpose({play, pause});
</script>

<style scoped>
  figure.video.wrapper {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    cursor: pointer;
    overflow: hidden;
  }

  figure.video.wrapper svg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    transform: scale(0.4);
    z-index: 99;
    transition: transform 0.1s ease-out;
    pointer-events: none;
  }

  figure.video.wrapper:hover svg {
    transform: scale(0.35);
  }

  figure.video.wrapper:active svg {
    transform: scale(0.45);
  }


  figure.video.wrapper svg path {
    fill: var(--light);
  }

  figure.video.wrapper img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    margin: auto;
    object-fit: fill;
    filter: grayscale(100%);
    opacity: 0.5;
  }

  .youtube.wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: opacity 0.5s ease-out;
  }

  .youtube.wrapper:not(.active) {
    pointer-events: none;
    opacity: 0.01;
  }

  .youtube.wrapper.active {
    pointer-events: all;
    opacity: 1;
  }

  figure.video.wrapper :deep(iframe) {
    vertical-align: bottom;
  }
</style>
